import { render, staticRenderFns } from "./PscDeficiencyCause.vue?vue&type=template&id=40cae4a6&scoped=true&"
import script from "./PscDeficiencyCause.vue?vue&type=script&lang=js&"
export * from "./PscDeficiencyCause.vue?vue&type=script&lang=js&"
import style0 from "./PscDeficiencyCause.vue?vue&type=style&index=0&id=40cae4a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cae4a6",
  null
  
)

export default component.exports